import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";

/* ═══════════════════════════════════════════════
   HOOK RESPONSIVE
═══════════════════════════════════════════════ */
const useWindowSize = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  useEffect(() => {
    const handle = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);
  return width;
};

/* ═══════════════════════════════════════════════
   MOBILE TOP BAR
═══════════════════════════════════════════════ */
const MobileTopBar = ({ stats }) => (
  <div style={mb.topBar}>
    <div style={mb.logo}>Trans<span style={{ color: "#16a34a" }}>TiGo</span></div>
    <div style={mb.badge}>Espace Transporteur</div>
    {stats && (
      <div style={mb.stats}>
        {stats.map(([v, l]) => (
          <div key={l} style={mb.statItem}>
            <div style={mb.statVal}>{v}</div>
            <div style={mb.statLabel}>{l}</div>
          </div>
        ))}
      </div>
    )}
  </div>
);

/* ═══════════════════════════════════════════════
   ICONS
═══════════════════════════════════════════════ */
const UserIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="5" r="3" stroke="#9ca3af" strokeWidth="1.5"/><path d="M2 13c0-2.8 2.7-5 6-5s6 2.2 6 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const MailIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="#9ca3af" strokeWidth="1.5"/><path d="M1 6l7 4 7-4" stroke="#9ca3af" strokeWidth="1.5"/></svg>;
const PhoneIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 1h4l1.5 4-2 1.2a9.1 9.1 0 004.3 4.3L12 8.5 16 10v4a2 2 0 01-2 2A15 15 0 011 3a2 2 0 012-2z" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const LockIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="8" rx="2" stroke="#9ca3af" strokeWidth="1.5"/><path d="M5 7V5a3 3 0 016 0v2" stroke="#9ca3af" strokeWidth="1.5"/></svg>;
const TruckIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="5" width="10" height="7" rx="1.5" stroke="#9ca3af" strokeWidth="1.5"/><path d="M11 7h2l2 3v2h-4V7z" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="4" cy="13" r="1.5" fill="#9ca3af"/><circle cx="12" cy="13" r="1.5" fill="#9ca3af"/></svg>;
const EyeIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="#9ca3af" strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke="#9ca3af" strokeWidth="1.5"/></svg>;
const EyeOffIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M6.5 6.6A2 2 0 0010 10M4 4.3C2.4 5.4 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M7 3.1C7.3 3 7.6 3 8 3c4.5 0 7 5 7 5s-.6 1.2-1.6 2.3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const AlertIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}><circle cx="8" cy="8" r="7" stroke="#f87171" strokeWidth="1.5"/><path d="M8 5v4M8 11v.5" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const ShieldIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 1L2 4v4c0 3.3 2.6 5.7 6 6.9C12.4 13.7 15 11.3 15 8V4L8 1z" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const GroupIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="#9ca3af" strokeWidth="1.5"/><path d="M1 14c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="#9ca3af" strokeWidth="1.2"/><path d="M14 14c0-2-1.3-3.5-3-4" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/></svg>;
const UploadIcon  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const DocIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="2" y="1" width="10" height="13" rx="1.5" stroke="#9ca3af" strokeWidth="1.5"/><path d="M5 5h5M5 8h5M5 11h3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/><path d="M10 1v3.5H14" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/></svg>;
//const IdCardIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="#9ca3af" strokeWidth="1.5"/><circle cx="5.5" cy="7.5" r="1.5" stroke="#9ca3af" strokeWidth="1.2"/><path d="M3 12c0-1.1 1.1-2 2.5-2s2.5.9 2.5 2" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/><path d="M10 7h3M10 9.5h2" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/></svg>;
//const LicenseIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="2" width="14" height="12" rx="2" stroke="#9ca3af" strokeWidth="1.5"/><path d="M4 6h4M4 9h6M4 12h3" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/><circle cx="12" cy="6" r="1.5" stroke="#9ca3af" strokeWidth="1.2"/></svg>;
//const CarIcon2    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 9l1.5-4h9L14 9" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/><rect x="1" y="9" width="14" height="4" rx="1.5" stroke="#9ca3af" strokeWidth="1.5"/><circle cx="4" cy="13.5" r="1.5" fill="#9ca3af"/><circle cx="12" cy="13.5" r="1.5" fill="#9ca3af"/></svg>;
const CheckCircle = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" fill="#4ade80"/><path d="M5 8l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const TrashIcon   = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5 4V2h6v2M6 7v5M10 7v5M3 4l1 10h8l1-10" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const SpinIcon    = () => <span style={{ display:"inline-block", width:14, height:14, border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"white", borderRadius:"50%", animation:"spin 0.6s linear infinite", marginRight:8, verticalAlign:"middle" }} />;

/* ═══════════════════════════════════════════════
   FIELD
═══════════════════════════════════════════════ */
const Field = ({ label, icon, eyeToggle, error, style: fieldStyle, ...inputProps }) => (
  <div style={fieldStyle}>
    {label && <label style={s.label}>{label}</label>}
    <div style={{ position: "relative" }}>
      {icon && <span style={s.inputIcon}>{icon}</span>}
      <input style={{ ...s.input, paddingLeft: icon ? 42 : 14, paddingRight: eyeToggle ? 42 : 14, borderColor: error ? "#f87171" : undefined }} {...inputProps} />
      {eyeToggle && (
        <button style={s.eyeBtn} type="button" onClick={eyeToggle.fn}>
          {eyeToggle.show ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      )}
    </div>
    {error && <div style={s.fieldError}>{error}</div>}
  </div>
);

/* ═══════════════════════════════════════════════
   FILE UPLOAD
═══════════════════════════════════════════════ */
const FileUpload = ({ label, name, hint, required, file, onFileChange, onRemove, error }) => {
  const inputRef = useRef(null);
  const isImage  = file && file.type && file.type.startsWith("image/");
  const preview  = file && isImage ? URL.createObjectURL(file) : null;

  return (
    <div style={{ marginBottom: 14 }}>
      <label style={s.label}>
        {label}{required && <span style={{ color: "#f87171", marginLeft: 3 }}>*</span>}
      </label>
      {hint && <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>{hint}</div>}
      {!file ? (
        <div style={{ ...s.dropZone, borderColor: error ? "#f87171" : undefined }}
          onClick={() => inputRef.current?.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) onFileChange(name, f); }}>
          <div style={{ color: "#9ca3af", marginBottom: 6 }}><UploadIcon /></div>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 2 }}>Cliquer ou glisser-déposer</div>
          <div style={{ fontSize: 11, color: "#bbb" }}>JPG, PNG ou PDF — max 5 Mo</div>
          <input ref={inputRef} type="file" accept="image/*,.pdf" style={{ display: "none" }}
            onChange={e => { if (e.target.files[0]) onFileChange(name, e.target.files[0]); }} />
        </div>
      ) : (
        <div style={s.filePreview}>
          {isImage && preview ? (
            <img src={preview} alt="aperçu" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 6, flexShrink: 0 }} />
          ) : (
            <div style={{ width: 48, height: 48, background: "#f0fdf4", border: "0.5px solid #bbf7d0", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><DocIcon /></div>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>{(file.size / 1024).toFixed(0)} Ko · <span style={{ color: "#16a34a" }}>✓ Prêt</span></div>
          </div>
          <button type="button" style={s.removeBtn} onClick={() => onRemove(name)} title="Supprimer"><TrashIcon /></button>
        </div>
      )}
      {error && <div style={s.fieldError}>{error}</div>}
    </div>
  );
};

/* ═══════════════════════════════════════════════
   STEP INDICATOR
═══════════════════════════════════════════════ */
const STEP_LABELS = ["Compte", "Société", "Documents", "Confirmation"];

const StepIndicator = ({ current }) => (
  <div style={s.steps}>
    {STEP_LABELS.map((label, i) => {
      const idx    = i + 1;
      const done   = idx < current;
      const active = idx === current;
      return (
        <React.Fragment key={label}>
          <div style={s.step}>
            <div style={{ ...s.stepCircle, background: done ? "#4ade80" : active ? "#0f1117" : "transparent", borderColor: done ? "#4ade80" : active ? "#0f1117" : "#e0e0e0", color: done || active ? "white" : "#bbb" }}>
              {done ? "✓" : idx}
            </div>
            <div style={{ fontSize: 10, color: active ? "#0f1117" : "#bbb", fontWeight: active ? 600 : 400 }}>{label}</div>
          </div>
          {i < STEP_LABELS.length - 1 && (
            <div style={{ flex: 1, height: "0.5px", background: done ? "#4ade80" : "#e0e0e0", alignSelf: "center", marginBottom: 18 }} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

/* ═══════════════════════════════════════════════
   PANEL GAUCHE (desktop)
═══════════════════════════════════════════════ */
const PanelLeft = () => (
  <div style={s.panel}>
    <svg style={s.panelGrid} viewBox="0 0 400 700" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="g3" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5"/>
        </pattern>
      </defs>
      <rect width="400" height="700" fill="url(#g3)"/>
      <circle cx="350" cy="100" r="220" fill="rgba(74,222,128,0.04)"/>
      <circle cx="60"  cy="580" r="180" fill="rgba(74,222,128,0.05)"/>
      <path d="M0 350 Q200 200 400 350 Q200 500 0 350Z" fill="rgba(74,222,128,0.03)"/>
    </svg>
    <div style={s.panelContent}>
      <div style={s.panelLogo}>Trans<span style={{ color: "#4ade80" }}>TiGo</span></div>
      <div style={{ margin: "auto 0" }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, color: "#4ade80", marginBottom: 10 }}>Espace Transporteur</div>
        <h2 style={s.panelTitle}>Développez votre activité avec nous</h2>
        <p style={s.panelSub}>Rejoignez 138 transporteurs qui font confiance à TransTiGo pour gérer leurs trajets et leurs clients.</p>
      </div>
      <div style={s.benefitGrid}>
        {[
          { icon: "📊", title: "Tableau de bord",     desc: "Gérez vos trajets, billets et revenus en temps réel." },
          { icon: "👥", title: "Accès aux clients",   desc: "Visibilité auprès de 2 841 voyageurs actifs." },
          { icon: "💳", title: "Paiements sécurisés", desc: "Encaissez directement via Mobile Money ou virement." },
          { icon: "✓",  title: "Badge vérifié",        desc: "Gagnez la confiance avec un profil certifié." },
        ].map(b => (
          <div key={b.title} style={s.benefitCard}>
            <span style={{ fontSize: 16, marginBottom: 6, display: "block" }}>{b.icon}</span>
            <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.8)", marginBottom: 4 }}>{b.title}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", lineHeight: 1.5 }}>{b.desc}</div>
          </div>
        ))}
      </div>
      <div style={s.docsNote}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#4ade80", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.8 }}>📋 Documents requis</div>
        {["Pièce d'identité (CIN / Passeport)", "Permis de conduire valide", "Carte de matriculation du véhicule", "Attestation de coopérative"].map(d => (
          <div key={d} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "rgba(255,255,255,0.45)", marginBottom: 5 }}>
            <span style={{ color: "#4ade80", fontSize: 10 }}>✓</span> {d}
          </div>
        ))}
      </div>
      <div style={{ paddingTop: 20, borderTop: "0.5px solid rgba(255,255,255,0.08)", fontSize: 12, color: "rgba(255,255,255,0.35)", fontStyle: "italic", lineHeight: 1.6 }}>
        "Depuis que je suis sur TransTiGo, mes réservations ont augmenté de 40% en 3 mois." — Rakoto C., Transporteur depuis 2023
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════════════
   TRANSPORTER REGISTER
═══════════════════════════════════════════════ */
const TransporterRegister = () => {
  const navigate  = useNavigate();
  const { login } = useAuth();
  const w         = useWindowSize();
  const isMobile  = w <= 768;

  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    name: "", phone: "", email: "", password: "", confirmPassword: "",
    companyName: "", vehicleType: "", capacity: "", cooperativeName: "",
  });
  const [files,      setFiles]      = useState({ cin: null, permis: null, matriculation: null, cooperative: null });
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");
  const [fieldErrors,setFE]         = useState({});
  const [fileErrors, setFileErrors] = useState({});
  const [showPwd,    setShowPwd]    = useState(false);
  const [showCPwd,   setShowCPwd]   = useState(false);
  const [agreed,     setAgreed]     = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    setFE(fe => ({ ...fe, [name]: "" }));
  };

  const handleFileChange = (name, file) => {
    if (file.size > 5 * 1024 * 1024) { setFileErrors(fe => ({ ...fe, [name]: "Fichier trop grand (max 5 Mo)" })); return; }
    setFiles(f => ({ ...f, [name]: file }));
    setFileErrors(fe => ({ ...fe, [name]: "" }));
  };
  const handleFileRemove = (name) => setFiles(f => ({ ...f, [name]: null }));

  const validateStep1 = () => {
    const errs = {};
    if (!form.name.trim())          errs.name  = "Requis";
    if (!form.phone.trim())         errs.phone = "Requis";
    if (!form.email.includes("@"))  errs.email = "Email invalide";
    if (form.password.length < 6)   errs.password = "6 caractères minimum";
    if (form.password !== form.confirmPassword) errs.confirmPassword = "Ne correspondent pas";
    return errs;
  };
  const validateStep2 = () => {
    const errs = {};
    if (!form.companyName.trim()) errs.companyName = "Requis";
    if (!form.vehicleType.trim()) errs.vehicleType = "Requis";
    return errs;
  };
  const validateStep3 = () => {
    const errs = {};
    if (!files.cin)           errs.cin           = "La pièce d'identité est requise";
    if (!files.permis)        errs.permis        = "Le permis de conduire est requis";
    if (!files.matriculation) errs.matriculation = "La carte de matriculation est requise";
    return errs;
  };

  const handleNext = () => {
    setError("");
    let errs = {};
    if (step === 1) errs = validateStep1();
    else if (step === 2) errs = validateStep2();
    else if (step === 3) errs = validateStep3();
    if (Object.keys(errs).length) { if (step === 3) setFileErrors(errs); else setFE(errs); return; }
    setStep(s => s + 1);
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    setError("");
    if (!agreed) { setError("Veuillez accepter les conditions."); return; }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("phone", form.phone);
      formData.append("email", form.email);
      formData.append("password", form.password);
      formData.append("company_name", form.companyName);
      formData.append("vehicle_type", form.vehicleType);
      formData.append("capacity", form.capacity);
      formData.append("cooperative_name", form.cooperativeName);
      if (files.cin)           formData.append("cin",           files.cin);
      if (files.permis)        formData.append("permis",        files.permis);
      if (files.matriculation) formData.append("matriculation", files.matriculation);
      if (files.cooperative)   formData.append("cooperative",   files.cooperative);
      const res = await api.post("/register-transporter", formData, { headers: { "Content-Type": "multipart/form-data" } });
      login(res.data.token, null);
      navigate("/transporter/dashboard");
    } catch { setError("Erreur lors de la création du compte. Cet email est peut-être déjà utilisé."); }
    setLoading(false);
  };

  const allDocsCount = Object.values(files).filter(Boolean).length;

  return (
    <div style={{ ...s.page, flexDirection: isMobile ? "column" : "row" }}>
      <style>{globalCSS}</style>

      {!isMobile && <PanelLeft />}

      <div style={{ ...s.formSide, padding: isMobile ? "0 20px 48px" : "40px 32px" }}>
        {isMobile && (
          <MobileTopBar stats={[["2 841", "Voyageurs"], ["138", "Transporteurs"], ["4.8★", "Note moy."]]} />
        )}

        <div style={{ ...s.formBox, paddingTop: isMobile ? 0 : 20 }}>
          <div style={{ ...s.formHeader, textAlign: isMobile ? "center" : "left" }}>
            <h1 style={{ ...s.formTitle, fontSize: isMobile ? 22 : 26 }}>Inscription Transporteur</h1>
            <p style={s.formSub}>Déjà un compte ? <Link to="/login" style={s.link}>Se connecter</Link></p>
          </div>

          <StepIndicator current={step} />

          {error && <div style={s.errorBox}><AlertIcon />{error}</div>}

          {/* ── STEP 1 ── */}
          {step === 1 && (
            <>
              <Field label="Nom du responsable" icon={<UserIcon />} name="name" placeholder="Prénom et nom" value={form.name} onChange={handleChange} error={fieldErrors.name} style={{ marginBottom: 14 }} />
              <Field label="Téléphone"           icon={<PhoneIcon />} name="phone" type="tel" placeholder="+261 34 XXX XXX" value={form.phone} onChange={handleChange} error={fieldErrors.phone} style={{ marginBottom: 14 }} />
              <Field label="Adresse email"        icon={<MailIcon />}  name="email" type="email" placeholder="vous@société.mg" value={form.email} onChange={handleChange} error={fieldErrors.email} style={{ marginBottom: 14 }} />

              <div style={{ marginBottom: 14 }}>
                <label style={s.label}>Mot de passe</label>
                <div style={{ position: "relative" }}>
                  <span style={s.inputIcon}><LockIcon /></span>
                  <input style={{ ...s.input, paddingLeft: 42, paddingRight: 42, borderColor: fieldErrors.password ? "#f87171" : undefined }}
                    type={showPwd ? "text" : "password"} name="password" placeholder="Minimum 6 caractères" value={form.password} onChange={handleChange} />
                  <button style={s.eyeBtn} type="button" onClick={() => setShowPwd(!showPwd)}>{showPwd ? <EyeOffIcon /> : <EyeIcon />}</button>
                </div>
                {fieldErrors.password && <div style={s.fieldError}>{fieldErrors.password}</div>}
              </div>

              <div style={{ marginBottom: 28 }}>
                <label style={s.label}>Confirmer le mot de passe</label>
                <div style={{ position: "relative" }}>
                  <span style={s.inputIcon}><LockIcon /></span>
                  <input style={{ ...s.input, paddingLeft: 42, paddingRight: 42, borderColor: fieldErrors.confirmPassword ? "#f87171" : (form.confirmPassword && form.password === form.confirmPassword ? "#4ade80" : undefined) }}
                    type={showCPwd ? "text" : "password"} name="confirmPassword" placeholder="Répétez votre mot de passe" value={form.confirmPassword} onChange={handleChange} />
                  <button style={s.eyeBtn} type="button" onClick={() => setShowCPwd(!showCPwd)}>{showCPwd ? <EyeOffIcon /> : <EyeIcon />}</button>
                </div>
                {fieldErrors.confirmPassword && <div style={s.fieldError}>{fieldErrors.confirmPassword}</div>}
              </div>

              <button style={s.submitBtn} onClick={handleNext} className="submit-btn">Continuer →</button>
            </>
          )}

          {/* ── STEP 2 ── */}
          {step === 2 && (
            <>
              <Field label="Nom de la société / Transporteur" icon={<TruckIcon />} name="companyName" placeholder="Ex: Rakoto Transport" value={form.companyName} onChange={handleChange} error={fieldErrors.companyName} style={{ marginBottom: 14 }} />

              <div style={{ marginBottom: 14 }}>
                <label style={s.label}>Type de véhicule</label>
                <div style={{ position: "relative" }}>
                  <span style={s.inputIcon}><TruckIcon /></span>
                  <select name="vehicleType" style={{ ...s.input, paddingLeft: 42, appearance: "none", borderColor: fieldErrors.vehicleType ? "#f87171" : undefined }} value={form.vehicleType} onChange={handleChange}>
                    <option value="">Sélectionner…</option>
                    <option>Bus (20+ places)</option>
                    <option>Minibus (10–20 places)</option>
                    <option>Taxi-brousse (9 places)</option>
                    <option>Taxi (4–5 places)</option>
                    <option>4x4 / SUV</option>
                  </select>
                </div>
                {fieldErrors.vehicleType && <div style={s.fieldError}>{fieldErrors.vehicleType}</div>}
              </div>

              <Field label="Capacité (nombre de places)" icon={<ShieldIcon />} name="capacity" type="number" placeholder="Ex: 14" value={form.capacity} onChange={handleChange} style={{ marginBottom: 14 }} />
              <Field label="Coopérative (facultatif)"    icon={<GroupIcon />}  name="cooperativeName" placeholder="Ex: Coopérative Fianarantsoa" value={form.cooperativeName} onChange={handleChange} style={{ marginBottom: 28 }} />

              <div style={{ display: "flex", gap: 10 }}>
                <button style={{ ...s.submitBtn, flex:"0 0 auto", width:"auto", padding:"13px 20px", background:"white", color:"#374151", border:"0.5px solid #e0e0e0" }} onClick={() => setStep(1)} type="button">← Retour</button>
                <button style={{ ...s.submitBtn, flex: 1 }} onClick={handleNext} className="submit-btn">Continuer →</button>
              </div>
            </>
          )}

          {/* ── STEP 3 ── */}
          {step === 3 && (
            <>
              <div style={s.docsInfoBanner}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#15803d", marginBottom: 4 }}>📋 Documents d'identité requis</div>
                <div style={{ fontSize: 12, color: "#166534", lineHeight: 1.6 }}>Ces documents seront vérifiés par notre équipe avant l'activation de votre compte. Formats acceptés : JPG, PNG, PDF (max 5 Mo).</div>
                <div style={{ marginTop: 8, display: "flex", gap: 6, alignItems: "center" }}>
                  <div style={{ fontSize: 11, color: "#15803d", fontWeight: 600 }}>{allDocsCount} / 4 document{allDocsCount !== 1 ? "s" : ""} ajouté{allDocsCount !== 1 ? "s" : ""}</div>
                  <div style={{ flex: 1, height: 4, background: "#dcfce7", borderRadius: 2, overflow: "hidden" }}>
                    <div style={{ width: `${(allDocsCount / 4) * 100}%`, height: "100%", background: "#16a34a", borderRadius: 2, transition: "width 0.3s ease" }} />
                  </div>
                </div>
              </div>

              <FileUpload label="Pièce d'identité"        name="cin"           hint="CIN ou Passeport"                              required  file={files.cin}           onFileChange={handleFileChange} onRemove={handleFileRemove} error={fileErrors.cin} />
              <FileUpload label="Permis de conduire"       name="permis"        hint="Permis en cours de validité, recto-verso"     required  file={files.permis}        onFileChange={handleFileChange} onRemove={handleFileRemove} error={fileErrors.permis} />
              <FileUpload label="Carte de matriculation"   name="matriculation" hint="Carte grise du véhicule utilisé"              required  file={files.matriculation} onFileChange={handleFileChange} onRemove={handleFileRemove} error={fileErrors.matriculation} />
              <FileUpload label="Attestation de coopérative" name="cooperative" hint="Facultatif — document d'adhésion"            required={false} file={files.cooperative} onFileChange={handleFileChange} onRemove={handleFileRemove} error={fileErrors.cooperative} />

              <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                <button style={{ ...s.submitBtn, flex:"0 0 auto", width:"auto", padding:"13px 20px", background:"white", color:"#374151", border:"0.5px solid #e0e0e0" }} onClick={() => setStep(2)} type="button">← Retour</button>
                <button style={{ ...s.submitBtn, flex: 1 }} onClick={handleNext} className="submit-btn">Continuer →</button>
              </div>
            </>
          )}

          {/* ── STEP 4 ── */}
          {step === 4 && (
            <>
              <div style={s.reviewCard}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8, color: "#9ca3af", marginBottom: 10 }}>Récapitulatif</div>
                {[["Responsable", form.name], ["Email", form.email], ["Téléphone", form.phone], ["Société", form.companyName], ["Véhicule", form.vehicleType], ["Capacité", form.capacity ? `${form.capacity} places` : "—"], ["Coopérative", form.cooperativeName || "—"]].map(([k, v]) => (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: "0.5px solid #f0f0f0" }}>
                    <span style={{ color: "#9ca3af" }}>{k}</span>
                    <span style={{ fontWeight: 500, color: "#374151" }}>{v || "—"}</span>
                  </div>
                ))}
              </div>

              <div style={{ ...s.reviewCard, marginTop: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8, color: "#9ca3af", marginBottom: 10 }}>Documents</div>
                {[{ key: "cin", label: "Pièce d'identité", required: true }, { key: "permis", label: "Permis de conduire", required: true }, { key: "matriculation", label: "Carte de matriculation", required: true }, { key: "cooperative", label: "Coopérative", required: false }].map(({ key, label, required }) => (
                  <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, padding: "5px 0", borderBottom: "0.5px solid #f0f0f0" }}>
                    <span style={{ color: "#9ca3af" }}>{label}{!required && <span style={{ fontSize: 10, color: "#bbb" }}> (opt.)</span>}</span>
                    {files[key] ? (
                      <span style={{ display: "flex", alignItems: "center", gap: 4, color: "#16a34a", fontWeight: 500, fontSize: 12 }}>
                        <CheckCircle /> {files[key].name.length > 20 ? files[key].name.slice(0, 20) + "…" : files[key].name}
                      </span>
                    ) : (
                      <span style={{ color: required ? "#f87171" : "#bbb", fontSize: 12 }}>{required ? "Manquant" : "Non fourni"}</span>
                    )}
                  </div>
                ))}
              </div>

              <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", marginBottom: 24, marginTop: 16 }}>
                <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{ marginTop: 2, accentColor: "#16a34a", width: 14, height: 14, flexShrink: 0 }} />
                <span style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
                  J'accepte les <Link to="/conditions" style={{ color: "#16a34a" }}>Conditions d'utilisation</Link> et la <Link to="/confidentialite" style={{ color: "#16a34a" }}>Politique de confidentialité</Link>. Je comprends que mon compte sera soumis à validation.
                </span>
              </label>

              <div style={{ display: "flex", gap: 10 }}>
                <button style={{ ...s.submitBtn, flex:"0 0 auto", width:"auto", padding:"13px 20px", background:"white", color:"#374151", border:"0.5px solid #e0e0e0" }} onClick={() => setStep(3)} type="button">← Retour</button>
                <button style={{ ...s.submitBtn, flex: 1 }} onClick={handleSubmit} disabled={loading} className="submit-btn">
                  {loading ? <><SpinIcon />Création…</> : "Créer mon compte"}
                </button>
              </div>
            </>
          )}

          <p style={{ fontSize: 12, color: "#bbb", textAlign: "center", marginTop: 20 }}>
            Vous êtes voyageur ? <Link to="/register" style={{ color: "#16a34a" }}>Créer un compte voyageur</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransporterRegister;

/* ── Styles ── */
const s = {
  page:         { display: "flex", minHeight: "100vh", fontFamily: "'Plus Jakarta Sans', sans-serif" },
  panel:        { width: "42%", background: "#111318", position: "relative", overflow: "hidden", flexShrink: 0 },
  panelGrid:    { position: "absolute", inset: 0, width: "100%", height: "100%" },
  panelContent: { position: "relative", zIndex: 1, display: "flex", flexDirection: "column", height: "100%", padding: "40px 44px" },
  panelLogo:    { fontSize: 22, fontWeight: 700, color: "white", letterSpacing: -0.5 },
  panelTitle:   { fontSize: 28, fontWeight: 700, color: "white", letterSpacing: -1, lineHeight: 1.2, marginBottom: 12 },
  panelSub:     { fontSize: 14, color: "rgba(255,255,255,0.4)", lineHeight: 1.7 },
  benefitGrid:  { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, margin: "20px 0 16px" },
  benefitCard:  { background: "rgba(255,255,255,0.04)", border: "0.5px solid rgba(255,255,255,0.06)", borderRadius: 10, padding: "14px 12px" },
  docsNote:     { background: "rgba(74,222,128,0.06)", border: "0.5px solid rgba(74,222,128,0.15)", borderRadius: 10, padding: "14px 16px", marginBottom: 20 },

  formSide:  { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", background: "white", padding: "40px 32px", overflowY: "auto" },
  formBox:   { width: "100%", maxWidth: 500 },
  formHeader:{ marginBottom: 24 },
  formTitle: { fontSize: 26, fontWeight: 700, letterSpacing: -0.8, color: "#0f1117", margin: "0 0 6px" },
  formSub:   { fontSize: 13, color: "#9ca3af", margin: 0 },
  link:      { color: "#16a34a", fontWeight: 600, textDecoration: "none" },

  steps:      { display: "flex", alignItems: "flex-end", marginBottom: 28 },
  step:       { display: "flex", flexDirection: "column", alignItems: "center", gap: 5 },
  stepCircle: { width: 28, height: 28, borderRadius: "50%", border: "0.5px solid", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700 },

  errorBox:   { display: "flex", alignItems: "center", gap: 8, background: "#fff5f5", border: "0.5px solid #fecaca", borderRadius: 9, padding: "10px 14px", marginBottom: 18, fontSize: 13, color: "#dc2626" },
  fieldError: { fontSize: 11, color: "#f87171", marginTop: 4 },
  label:      { display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, letterSpacing: 0.2 },
  input:      { width: "100%", padding: "11px 14px", border: "0.5px solid #e0e0e0", borderRadius: 10, fontSize: 14, fontFamily: "inherit", color: "#0f1117", background: "white", outline: "none", boxSizing: "border-box", transition: "border-color 0.15s" },
  inputIcon:  { position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", pointerEvents: "none" },
  eyeBtn:     { position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center" },
  submitBtn:  { width: "100%", padding: "13px 0", background: "#0f1117", color: "white", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 },
  reviewCard: { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 10, padding: "14px 16px" },
  dropZone:   { border: "1.5px dashed #e0e0e0", borderRadius: 10, padding: "28px 20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer", background: "#fafafa", transition: "border-color 0.15s, background 0.15s", textAlign: "center" },
  filePreview:{ display: "flex", alignItems: "center", gap: 12, background: "white", border: "0.5px solid #d1fae5", borderRadius: 10, padding: "10px 14px" },
  removeBtn:  { background: "#fff5f5", border: "0.5px solid #fecaca", borderRadius: 6, cursor: "pointer", padding: "6px 8px", display: "flex", alignItems: "center", flexShrink: 0 },
  docsInfoBanner:{ background: "#f0fdf4", border: "0.5px solid #bbf7d0", borderRadius: 10, padding: "14px 16px", marginBottom: 20 },
};

/* ── Mobile top bar styles ── */
const mb = {
  topBar:    { width: "100%", background: "#111318", padding: "24px 20px 20px", marginBottom: 28, borderRadius: "0 0 18px 18px", textAlign: "center" },
  logo:      { fontSize: 22, fontWeight: 800, color: "white", letterSpacing: -0.5, marginBottom: 8 },
  badge:     { display: "inline-block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, color: "#4ade80", background: "rgba(74,222,128,0.1)", border: "0.5px solid rgba(74,222,128,0.2)", borderRadius: 20, padding: "3px 10px", marginBottom: 16 },
  stats:     { display: "flex", justifyContent: "space-around" },
  statItem:  { display: "flex", flexDirection: "column", alignItems: "center" },
  statVal:   { fontSize: 16, fontWeight: 700, color: "white", letterSpacing: -0.5 },
  statLabel: { fontSize: 10, color: "rgba(255,255,255,0.4)", marginTop: 2 },
};

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
  @keyframes spin { to { transform: rotate(360deg); } }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  input:focus, select:focus { border-color: #16a34a !important; box-shadow: 0 0 0 3px rgba(22,163,74,0.08) !important; }
  .submit-btn:hover:not(:disabled) { background: #1a1a1a !important; }
  .submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
`;